<template>
  <el-container  style="display: block;">

    <el-row  class="tui-el"  style="margin-top: 20px;margin-left: 3%;">

      <el-row :span="2" style="margin-top: 30px;">
          <el-input v-model="seachName" style="width: 150px;" placeholder="请输入模型名"></el-input>
          <el-input v-model="nameg" style="width: 150px;" placeholder="请输入模型关联词"></el-input>
          <el-select v-model="groupNameg" @change="loadList()"  filterable placeholder="请选择分组" >
              <el-option
                v-for="item in groupName"
                :key="item.gname"
                :label="item.gname"

                :value="item.gname">
              </el-option>
            </el-select>
          <el-button type="primary" style="background-color: #409eff;" @click="seach()" round>搜索</el-button>
      </el-row>

        <el-row  class="elementsz" style="margin-top: 30px;">
          <template>
            <el-table
          	:data="list"
            height="1000"
          	border
          	style="width: 100%;margin-left: 0;height: 800px;text-align: center;">
            <el-table-column

              width="300"
              label="关联词"
               >
               <template slot-scope="scope">
                   <div>{{scope.row.shiping}}</div>
               </template>
            </el-table-column>
          	<el-table-column

              width="250"
          	  label="模型"
          	   >
              <template slot-scope="scope">

                <el-row v-if="scope.row.img_s == 0">
                  ({{scope.row.gname}})+({{scope.row.name}})
                  <el-col :span="20" style="text-align: center;margin-top: 20px;" @click.native="seeImg(scope.$index,scope.row)">
                    查看图片

                  </el-col>





                </el-row>
                <el-row v-if="scope.row.img_s == 1">
                  ({{scope.row.name}})+({{scope.row.gname}})
                  <img v-if="scope.row.img" :src="scope.row.img" class="avatar">





                </el-row>
              </template>
          	</el-table-column>

            <el-table-column

              width="400"
              label="音乐地址"
               >
               <template slot-scope="scope">
                   <div  @click="dischangeshi(3,scope.row.music,scope.row.id)">{{scope.row.music}}</div>
               </template>
            </el-table-column>

            <el-table-column

              width="400"
              label="视频地址"
               >
               <template slot-scope="scope">
                   <div  @click="dischangeshi(1,scope.row.urlmp4,scope.row.id)">{{scope.row.urlmp4}}</div>
               </template>
            </el-table-column>
            <el-table-column

              width="400"
              label="新闻地址"
               >
               <template slot-scope="scope">
                   <div  @click="dischangeshi(4,scope.row.news,scope.row.id)">{{scope.row.news}}</div>
               </template>
            </el-table-column>
            <el-table-column

              width="400"
              label="购买地址"
               >
               <template slot-scope="scope">
                   <div  @click="dischangeshi(6,scope.row.good,scope.row.id)">{{scope.row.good}}</div>
               </template>
            </el-table-column>
            <el-table-column

              width="400"
              label="百科地址"
               >
               <template slot-scope="scope">
                   <div  @click="dischangeshi(7,scope.row.baike,scope.row.id)">{{scope.row.baike}}</div>
               </template>
            </el-table-column>

            <el-table-column

              width="400"
              label="其他地址"
               >
               <template slot-scope="scope">
                   <div  @click="dischange(6,scope.row.url,scope.row.id,2)">{{scope.row.url}}</div>
               </template>
            </el-table-column>
            <el-table-column

              width="400"
              label="音频指令"
               >
               <template slot-scope="scope">
                   <div  @click="dischange(8,scope.row.musiczhiling,scope.row.id,2)">{{scope.row.musiczhiling}}</div>
               </template>
            </el-table-column>
            <el-table-column

              width="400"
              label="其他指令"
               >
               <template slot-scope="scope">
                   <div  @click="dischange(7,scope.row.zhiling,scope.row.id,2)">{{scope.row.zhiling}}</div>
               </template>
            </el-table-column>



            </el-table>
          </template>
          <div class="page">
          	<el-pagination
          	  @size-change="loadList()"
          	  @current-change="loadList()"
          	  :current-page.sync="page"
          	  :page-size="10"
          	  background
          	  layout="total,prev, pager, next, jumper"
          	  :total="count">
          	</el-pagination>
          </div>
        </el-row>






    </el-row>


    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%"
      >
      <span>确认删除？</span>
      <span slot="footer" class="dialog-footer">
    	<el-button @click="dialogVisible = false">取 消</el-button>
    	<el-button type="primary" @click="doDell()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="修改"
      :visible.sync="disDialogVisible"
      width="30%"
      center>
      <input type="text" class="searchT" v-model="disName"/>
      <span slot="footer" class="dialog-footer">
    	<el-button @click="disDialogVisible = false">取 消</el-button>
    	<el-button type="primary" @click="dodisChange()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="修改"
      :visible.sync="disDialogVisibleshi"
      width="30%"
      center>
      <input type="text" class="searchT" v-model="disNameshi"/>
      <span slot="footer" class="dialog-footer">
    	<el-button @click="disDialogVisibleshi = false">取 消</el-button>
    	<el-button type="primary" @click="dodisChangeshi()">确 定</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>
<style>
  th div{
    text-align: center;
  }
</style>
<script>

  export default {
    data() {
       return {
         page:1,
         count:0,
        options: [],
        delId:'',
        delIndex:'',
        dialogVisible:false,
        value: '',
        addImg:'',
        addImgs:'',
        newName:'',
        imageId: 0,
        list: [],
        search:'',
        w:0,
        h:0,
        chi:0,
        disName:'',
        disNameshi:'',

        disDialogVisible:false,
        disDialogVisibleshi:false,
        disId:0,
        disIdshi:0,
        seachName:'',
        gName:'',
        groupName:'',
        groupNameg:'',
        url:'无',
        zhiling:'无',
        urlmp4:'无',
        news:'无',
        music:'无',
        shiping:'无',
        bgm:'无',
        goods:'无',
        baike:'无',
        musiczhiling:'无',
        nameg:''

      }
    },
	directives: {
    },
    created() {
      if(!window.localStorage.getItem('id')){
        this.$router.push({ path: '/' })
      }
      this.loadList();
      var lett = this;
       document.onkeydown = function(e) {
       var key = window.event.keyCode;
       if (key == 13) {
         lett.seach();
       }
      }
    },

	methods:{
    seeImg(index,row){
      row['img_s'] = 1
      // this.list[index]['img_s'] = 1;
      this.$set(this.list,index,row);
      // console.log(this.list[index]['img_s'])
      // this.$forceUpdate()


    },
    seach(){
      this.loadList();
    },
    dischange(t,name,id){
      return false
      this.t = t;
      this.disId = id
      this.disName = name
      this.disDialogVisible = true
    },
    dodisChange(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          id:this.disId,
          name:this.disName,
          t:this.t
      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/elementdtChanges'
      })
      .then(res=>{
        console.log(res.data.code)
        if(res.data.code == 200){
          this.disDialogVisible = false
          this.loadList()
        }else{
          this.msg('名称重复','error');
          this.disDialogVisible = false

        }



      })
      .catch(err=>{

      });
    },
    dischangeshi(t,name,id){
      return false
      this.tshi = t;
      this.disIdshi = id
      this.disNameshi = name
      this.disDialogVisibleshi = true
    },
    dodisChangeshi(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          id:this.disIdshi,
          name:this.disNameshi,
          t:this.tshi
      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/elementdtChangesshi'
      })
      .then(res=>{
        console.log(res.data.code)
        if(res.data.code == 200){
          this.disDialogVisibleshi = false
          this.loadList()
        }else{
          this.msg('修改失败','error');
          this.disDialogVisibleshi = false

        }



      })
      .catch(err=>{

      });
    },
    aa(t){
      let date = new Date();
      let y = date.getFullYear();
      let m = date.getMonth() + 1;
      let d = date.getDate();
      m = m < 10 ? "0" + m : m;
      d = d < 10 ? "0" + d : d;
        if(t == 1){
          return y + "-" + m + "-01 00:00:00";
        }else{
          return y + "-" + m + "-" + d +" 23:59:59";
        }

    },

    UploadUrl(id){
      return "http://fencip.yoooooo.com/index.php/index/data/pythondtChange?id="+id
    },
    onChangeStripe(){
      this.loadList()
    },

    loadList(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'get',
      	params:{
          name:this.seachName,
          nameg:this.nameg,
          p:this.page,
          gname:this.groupNameg
      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/elementdtNewl'
      })
      .then(res=>{
        this.groupName = res.data.group;
        this.list = res.data.list;
        this.list.forEach(function(item, index) {
              item['img_s'] = 0;
        })

        this.count = res.data.count;
      	// this.list = res.data;

      })
      .catch(err=>{

      });
    },
    handleAvatarSuccess1(res, file){


      this.addImg = URL.createObjectURL(file.raw);
      this.addImgs = file.response.data
      console.log(this.addImgs)
    },
    handleAvatarSuccess(res, file) {


      this.list[this.imageId]['img'] = URL.createObjectURL(file.raw);
    },
    ceshi(index){
      this.imageId = index
    },
    del(id,index){
      this.dialogVisible = true
      this.delId = id
      this.delIndex = index

    },

    kg(id){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });


      axiosInstance({
      	method:'post',
      	params:{
      		id:id,
      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/elementdtkgChanges'
      })
      .then(res=>{
      	if(res.data.code == 200){

           this.$message({
           	type: 'success',
           	message: '操作成功'
           });
           this.loadList()

      	}else{
          this.$message({
          	type: 'error',
          	message: '操作失败'
          });
      	}

      })
      .catch(err=>{

      });
    },
    move(id){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });

      axiosInstance({
      	method:'post',
      	params:{
      		id:this.id,
      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/elementdtMoveshi'
      })
      .then(res=>{
      	if(res.data.code == 200){
           this.$message({
           	type: 'success',
           	message: '操作成功'
           });
      	}

      })
      .catch(err=>{

      });
    },
    doDell(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });

      if(this.delId == ''){
         return false
      }
      axiosInstance({
      	method:'post',
      	params:{
      		id:this.delId,
      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/elementdtDel'
      })
      .then(res=>{
      	if(res.data.code == 200){
           this.delId = 0
           this.dialogVisible = false
           this.list.splice(this.delIndex,1)
           this.delIndex = ''
           this.$message({
           	type: 'success',
           	message: '操作成功'
           });

      	}else{
           this.dialogVisible = false
      	}

      })
      .catch(err=>{

      });
    },
    add(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      if(this.newName == ''){
        this.msg('请填写名称','error')
        return false
      }
      if(this.gName == ''){
        this.msg('请填写组名','error')
        return false
      }
      if(this.addImgs == ''){
        this.msg('请选择图片','error')
        return false
      }
      console.log(this.addImgs)
      axiosInstance({
      	method:'post',
      	url:'http://fencip.yoooooo.com/index.php/index/data/elementdtAddTB',
      	params:{
      		name:this.newName,
          gname:this.gName,
      		url:this.addImgs,
          l_id:this.value,
          w:this.w,
          h:this.h,
          chi:this.chi,
          urls:this.url,
          zhiling:this.zhiling,
          urlmp4:this.urlmp4,
          news:this.news,
          music:this.music,
          shiping:this.shiping,
          bgm:this.bgm,
          goods:this.goods,
          baike:this.baike,
          musiczhiling:this.musiczhiling
      	}
      })
      .then(res=>{
      	this.tableData = res.data.data
        this.addImgs = ''
        this.addImg = ''
        this.newName = ''
        this.loadList()
      })
      .catch(err=>{

      });
    },
    msg(msg,type){
    	this.$message({
    	  message: msg,
    	  type: type
    	});
    },

	}


  }
</script>

<style>
  .tui-content{
    margin-left: 24%;
    margin-top: 100px;
  	width: 100%;
  	height: 100%;
  }
  .tui-el{
    width: 80%;
  }
  .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
      border-color: #409EFF;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 60px;
      height: 60px;
      line-height: 60px;
      text-align: center;
    }
    .avatar {
      width: 60px;
      height: 60px;
      display: block;
    }
</style>



// WEBPACK FOOTER //
// src/components/main/elementdtl.vue